import React from 'react';
import './RichTextDisplay.css';

const RichTextDisplay = ({ content, className = "", style = {} }) => {
  // If content is empty or undefined, return fallback
  if (!content) {
    return null;
  }

  // Check if content is HTML (contains HTML tags)
  const isHTML = /<[a-z][\s\S]*>/i.test(content);
  
  // If it's plain text, just return it in a paragraph
  if (!isHTML) {
    return <p className={className} style={style}>{content}</p>;
  }

  // Simple HTML sanitization (basic security measure)
  // Remove script tags and other potentially dangerous content
  const sanitizedContent = content
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, '')
    .replace(/javascript:/gi, '')
    .replace(/on\w+\s*=/gi, '');

  return (
    <div 
      className={`rich-text-content ${className}`}
      style={style}
      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
    />
  );
};

export default RichTextDisplay;
